export const MAX_CONTENT_WIDTH = "90rem";
export const CONTENT_PADDING = "2rem";
